import type { Decoration_Type, DocumentStyle } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { RicosTheme } from './../../ricos-types';

import { Decorations } from '../decorations';
import { RicosNodeStyle } from '../document-style/node-style';
import { RicosTextStyle } from '../document-style/text-style';
import type { TextDecoration } from '../models/decoration';
import type { TextBlockNodeType } from '../models/styles';
import { TextStyleTransformer } from '../text-style-transformer';
import themeStrategy from '../themeStrategy/themeStrategy';

/**
 * Represents textual portion of Ricos Theme
 */
export default class RicosTextualTheme {
  theme: RicosTheme;

  documentStyle: DocumentStyle;

  constructor(theme: RicosTheme) {
    this.theme = theme;
    this.documentStyle = TextStyleTransformer.fromTheme(this.theme).toDocumentStyle();
  }

  /**
   * Extracts given decoration settings for specific node type from the current theme.
   */
  getDecoration(nodeType: TextBlockNodeType, decorationType: Decoration_Type): TextDecoration {
    const textNodeStyle = this.documentStyle[nodeType];
    return Decorations.of(textNodeStyle?.decorations || []).byType(decorationType);
  }

  getTextStyle(nodeType: TextBlockNodeType) {
    return RicosTextStyle.of({ lineHeight: this.documentStyle[nodeType]?.lineHeight });
  }

  getNodeStyle(nodeType: TextBlockNodeType) {
    return RicosNodeStyle.of(this.documentStyle[nodeType]?.nodeStyle);
  }

  /**
   * Translates RicosTheme to HTML style tag with CSS variable definitions
   */
  toStyleTag() {
    return themeStrategy({ ricosTheme: this.theme }).html;
  }

  /**
   * Returns palette colors for the current theme
   */
  getColors() {
    return themeStrategy({ ricosTheme: this.theme }).themeData.colors || {};
  }
}
